import { type components } from '@heidi/schema/ml-scribe';
import { useMutation } from '@tanstack/react-query';

import { CHANGE_EMAIL_REQUEST } from '../../contracts/keys';
import { requestEmailChange } from '../api/email-change';

export type ChangeEmailRequestInput = components['schemas']['RequestEmailChangeRequest'];
export type ChangeEmailRequestResponse =
  components['schemas']['RequestEmailChangeResponse'];

export interface UseChangeEmailRequestOptions {
  onSuccess?: (data: ChangeEmailRequestResponse) => void;
  onError?: (error: unknown) => void;
}

export function useChangeEmailRequest(options?: UseChangeEmailRequestOptions) {
  return useMutation({
    mutationKey: [CHANGE_EMAIL_REQUEST],
    mutationFn: async (data: ChangeEmailRequestInput) => {
      const response = await requestEmailChange(data);
      return response.data;
    },
    onSuccess: (data) => {
      options?.onSuccess?.(data);
    },
    onError: (error) => {
      options?.onError?.(error);
    },
  });
}
